import o from "./_root.js";
var m = o.Symbol;
const t = m;
export {
  t as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_Symbol.js
// module id = 250
// module chunks = 67